export default "__VITE_ASSET__Cf6Z_1vK__"